/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {
    getFrontCoverPageDetailsSuccess,
    getCoverPageThumbnailsSuccess,
    getFrontCoverThumbnailURLSuccess
} from "../_actions/bookdetails.actions";
import api from "./api.services";
import {fetchApiDataFailure} from "../_actions/common.actions";
import axios from "axios/index";

export const getFrontCoverPageDetails = (collectionId) => dispatch => {

    axios.get(api.get_front_cover_page_details.replace('{collection-id}',collectionId))
        .then(response =>{
            dispatch(getFrontCoverPageDetailsSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};

export const getFrontCoverThumbnailURL = (collectionId, printPageType) => dispatch => {

    axios.get(api.get_print_page.replace('{collection-id}',collectionId).replace('{print-page-type}', printPageType))
        .then(response =>{
            dispatch(getFrontCoverThumbnailURLSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};


// WEBPACK FOOTER //
// ./src/_thunks/cover.thunk.js